import jsonp from "../../assets/js/http"
import _cookie from "../../assets/js/cookie"

const state = {
  peopleData: {
    total:0
  },
  likeNum:0,
  isRewardClick:false
}

const getters = {
  getPeople(state: any) {
    return state.peopleData;
  },
  getLike(state: any) {
    return state.likeNum;
  },
  getIsRewardClick(state: any) {
    return state.isRewardClick;
  },
  setLike(state: any) {
    return state.likeNum;
  }
}

const actions = {
  getPeopleAsync(context: any,data:any) {//获取人数
    return new Promise((resolve, reject) => {
      jsonp(data.url,{
        jsonp: data.callback,
        jsonpcallback: data.callback
      }).then((res:any) => {
          context.commit('setPeople', res)
          resolve(res);
      });
    })    
  },
  getLikeAsync(context: any,data:any) {//获取喜欢数
      return new Promise((resolve, reject) => {
          jsonp(data.url,{
            jsonpcallback: data.callback
          }).then((res:any) => {
              if(res.likes > state.likeNum ){
                  context.commit('setLike', res.likes)
              }
              resolve(res);
          });
      })
  },
  setLikeAsync(context: any,likes:any){
    context.commit('setLike', likes)
  },
  setIsRewardClickAsync(context: any,val:any){
    context.commit('setIsRewardClick', val)
  }
}

const mutations = {
  setPeople(state: any, res: any) {
      state.peopleData=res;
  },
  setLike(state: any, res: any) {
    state.likeNum=res;
  },
  setIsRewardClick(state: any, res: any) {
    state.isRewardClick=res;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
